import { tw } from "@careinfo/tailwind";
import { Table } from "@tanstack/react-table";
import { Dispatch, SetStateAction } from "react";
import { useSearchParams } from "react-router-dom";

interface Props {
  serverData: any;
  limit: number;
  table: Table<any>;
  setLimit: Dispatch<SetStateAction<number>>;
}

export default function TablePagination({
  serverData,
  limit,
  table,
  setLimit,
}: Props) {
  const [searchParams, setSearchParams] = useSearchParams();
  const page = parseInt(searchParams.get("page") ?? "0");

  const handleNextPage = () => {
    const currentPage = isNaN(page) ? 0 : page;
    searchParams.set("page", String(currentPage + 1));
    setSearchParams(searchParams);
  };

  const handlePreviousPage = () => {
    const currentPage = isNaN(page) ? 0 : page;
    searchParams.set("page", String(currentPage - 1));
    setSearchParams(searchParams);
  };

  const handleLastpage = () => {
    searchParams.set("page", String(Math.floor(serverData?.count / limit)));
    setSearchParams(searchParams);
  };

  const handleFirstPage = () => {
    searchParams.set("page", "");
    setSearchParams(searchParams);
  };

  return (
    <div className={tw`flex bg-white py-2  w-full justify-center gap-4`}>
      <button
        className={tw`border hidden md:block rounded p-1`}
        onClick={() => handleFirstPage()}
        disabled={!serverData?.previous}
      >
        {"<<"}
      </button>
      <button
        className={tw`border rounded p-1`}
        onClick={() => handlePreviousPage()}
        disabled={!serverData?.previous}
      >
        {"<"}
      </button>
      <button
        className={tw`border rounded p-1`}
        onClick={() => handleNextPage()}
        disabled={!serverData?.next}
      >
        {">"}
      </button>
      <button
        className={tw`border hidden md:block rounded p-1`}
        onClick={() => handleLastpage()}
        disabled={!serverData?.next}
      >
        {">>"}
      </button>
      <span className={tw`flex items-center gap-1`}>
        <div>Page</div>
        <strong>
          {(isNaN(page) ? 0 : page) + 1} of{" "}
          {Math.ceil(serverData?.count / limit)}
        </strong>
      </span>
      <select
        value={table.getState().pagination.pageSize}
        onChange={(e) => {
          setLimit(Number(e.target.value));
          searchParams.set("limit", e?.target?.value);
          setSearchParams(searchParams);
        }}
      >
        {[10, 50, 100, 200, 500].map((pageSize) => (
          <option key={pageSize} value={pageSize}>
            Show {pageSize}
          </option>
        ))}
      </select>
      <p className={tw`mt-1`}>All: {serverData?.count}</p>
    </div>
  );
}
